import { useEffect, useState } from 'react';
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';

import { ReactComponent as CloseIcon } from './Close.svg';
import { scrollIntoFrameView } from 'iframe';

import './mockJquery.d.ts';
import './index.css';

// Pseudo-jQuery for Hubspot callbacks to avoid loading jQuery script
// jQuery is needed for hubspot forms onFormSubmit method, but only as query tool, so we can improve performance by not loading jQuery

interface MoreToolsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmitted?: () => void;
}

export const MoreToolsModal = ({
  onClose,
  isOpen,
  onSubmitted,
}: MoreToolsModalProps) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  useHubspotForm({
    // @ts-ignore
    region: 'na1',
    portalId: '9021803',
    formId: 'b320dbea-707a-4345-8bcd-b9521d6e048c',
    sfdcCampaignId: '7014v000002S169AAC',
    target: '#hubspotForm',
    onFormReady() {
      // this hack is needed to update value properly because this method is called is updating the value after running it, we need to pop it out from callstack and run afterwards
      setTimeout(() => {
        (
          document.querySelector(
            'input[type="submit"].hs-button'
          ) as HTMLInputElement
        ).value = 'Get More Tools';
      }, 20);
    },
    onFormSubmit() {
      const conversionPageInput = document.querySelector(
        'input[name="conversion_page"]'
      ) as HTMLInputElement;

      if (!conversionPageInput.value) {
        conversionPageInput.value = 'oysterlabs_timezone_crossover_calculator';
        conversionPageInput.dispatchEvent(
          new Event('input', { bubbles: true })
        );
      }
    },
    onFormSubmitted() {
      setIsSubmitted(true);
      onSubmitted?.();
    },
  });

  useEffect(() => {
    if (isOpen) {
      scrollIntoFrameView();
    }
  }, [isOpen]);

  return (
    <div
      onClick={() => {
        onClose();
      }}
      className="modal-overlay"
      style={{
        display: isOpen ? 'flex' : 'none',
      }}
    >
      <div
        style={{
          position: 'absolute',
          marginTop: '60px',
        }}
        className="modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <CloseIcon
          width={50}
          height={50}
          className="close-icon"
          onClick={onClose}
        />
        {!isSubmitted && (
          <div className="modal-heading">
            Get unlimited access to the Time Zone Crossover Calculator and
            Oyster's full suite of free global employment tools
          </div>
        )}
        <div id="hubspotForm" />
      </div>
    </div>
  );
};
